import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=70ffd86c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=70ffd86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ffd86c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ffd86c')) {
      api.createRecord('70ffd86c', component.options)
    } else {
      api.reload('70ffd86c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=70ffd86c&scoped=true&", function () {
      api.rerender('70ffd86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-280zw54Rxwdxj/JS/comp/PopupDialog.vue"
export default component.exports